import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGarage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconGarage"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2.89099L22 8.47658V20.0001H2V8.47658L12 2.89099ZM7.5 18.5001H16.5V16.0001H7.5V18.5001ZM7.5 14.5001H16.5V12.0001H7.5V14.5001Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGarage;
